(function() {
	'use strict';

	angular.module('smb-app')
		.factory('smbDocumentDetailsPanelDataStore', ['smbPanelDetailsDataStore', DocumentDetailsPanelDataStore]);

	/**
	 * @ngdoc service
	 * @name smb-app.smbDocumentDetailsPanelDataStore
	 *
	 * @description
	 * This datastore manages the state of the document details related content
	 * within the application's side panel. It consumes the general smbPanelDetailsDataStore
	 * to control the side panel itself.
	 */
	function DocumentDetailsPanelDataStore(smbPanelDetailsDataStore) {
		// Panel names
		var _fieldPanel = 'index-panel';
		var _fieldEdit = 'index-edit';
		var _history = 'history';
		var _comments = 'comments';

		var _currentPanel;

		return {
			/**
			 * @ngdoc property
			 * @name smbDocumentDetailsPanelDataStore#showFieldPanel
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Returns true if the document field panel should be displayed in
			 * the document details panel.
			 */
			get showFieldPanel() { return _currentPanel === _fieldPanel; },  /* TODO: Change name to `showFieldPanel` */

			/**
			 * @ngdoc property
			 * @name smbDocumentDetailsPanelDataStore#showFieldEdit
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Returns true if the field edit form should be displayed in the document details panel.
			 */
			get showFieldEdit() { return _currentPanel === _fieldEdit; }, /* TODO: Change name to `showFieldEdit` */

			/**
			 * @ngdoc property
			 * @name smbDocumentDetailsPanelDataStore#showHistory
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Returns true if the history panel should be displayed in the document details panel.
			 */
			get showHistory() { return _currentPanel === _history; },

			/**
			 * @ngdoc property
			 * @name smbDocumentDetailsPanelDataStore#showComments
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Returns true if the comments panel should be displayed in the document details panel.
			 */
			get showComments() { return _currentPanel === _comments; },

			/**
			 * @ngdoc property
			 * @name smbDocumentDetailsPanelDataStore#fieldPanel
			 * @propertyOf smb-app.smbDcoumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Constant that represents the name of the field panel.
			 */
			get fieldPanel() { return _fieldPanel; },

			/**
			 * @ngdoc property
			 * @name smbDcoumentDetailsPanelDataStore#fieldEditPanel
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Constant that represents the name of the field edit form panel.
			 */
			get fieldEditPanel() { return _fieldEdit; },

			/**
			 * @ngdoc property
			 * @name smbDcoumentDetailsPanelDataStore#historyPanel
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Constant that represents the name of the history panel.
			 */
			get historyPanel() { return _history; },

			/**
			 * @ngdoc property
			 * @name smbDcoumentDetailsPanelDataStore#commentsPanel
			 * @propertyOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind property
			 *
			 * @description
			 * Constant that represents the name of the comments panel.
			 */
			get commentsPanel() { return _comments; },

			/**
			 * @ngdoc method
			 * @name smbDcoumentDetailsPanelDataStore#toggle
			 * @methodOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind method
			 *
			 * @description
			 * Toggle the document details side panel with a specific page of the panel.
			 * If passing the name of the panel page that is currently displayed, it will
			 * close the entire side panel. If the side panel is already open but toggled
			 * with a different page, the side panel will stay open and will switch to
			 * the new page. If the argument is not a valid document details panel page,
			 * then nothing happens.
			 *
			 * @param {string} panelName Then name of document details panel to display.
			 */
			toggle: toggle,

			/**
			 * @ngdoc method
			 * @name smbDcoumentDetailsPanelDataStore#closePanel
			 * @methodOf smb-app.smbDocumentDetailsPanelDataStore
			 * @kind method
			 *
			 * @description
			 * Closes the document details panel as well as the general app side panel.
			 */
			closePanel: closePanel
		};

		function closePanel() {
			_currentPanel = undefined;
			smbPanelDetailsDataStore.reset();
		}

		function toggle(panelName) {
			if (!smbPanelDetailsDataStore.isOpen) {
				_currentPanel = undefined;
			}

			if ([_fieldPanel, _fieldEdit, _history, _comments].indexOf(panelName) < 0) {
				return;
			}

			if (panelName === _currentPanel) {
				// close the panel
				closePanel();
			} else {
				if (!_currentPanel) {
					smbPanelDetailsDataStore.toggle();
				}
				_currentPanel = panelName;
			}
		}
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/dataStores/documentDetailsPanelDataStore.js
// module id = 120
// module chunks = 1